import React, { useState } from "react";
import classes from "./ServicesComponents.module.scss";
import Button from "../UI/Button";
import ServicesTable from "./ServicesTable";
import LoadingDots from "../UI/LoadingDots";

const ServicesTableCont = ({
  data,
  dataType,
  getData,
  isLoading,
  onCopyServices,
}) => {
  console.log("new data");
  const [isEditMode, setIsEditMode] = useState(false);

  const onCancelEditing = () => {
    getData(() => setIsEditMode(false));
    // setIsEditMode(false);
  };

  return (
    <section>
      <div className={classes.titleBtnContainer}>
        <h2 className={classes.subtitle}>Service credentials</h2>
        {!isEditMode && (
          <>
            <button
              className={`${classes.refreshBtn} px-4 py-1`}
              onClick={() => onCopyServices()}
            >
              Refresh service credentials
            </button>
            <Button className="px-5 py-1" onClick={() => setIsEditMode(true)}>
              Edit
            </Button>
          </>
        )}
      </div>
      {!isLoading ? (
        <ServicesTable
          data={data}
          dataType={dataType}
          isEditMode={isEditMode}
          onCancelEditing={onCancelEditing}
        />
      ) : (
        <LoadingDots />
      )}
    </section>
  );
};

export default ServicesTableCont;
